import React, {useState} from 'react';

import {reduxForm, InjectedFormProps, SubmissionError, FormErrors} from 'redux-form';
import {Forms} from '../../../../../shared/models/forms';
import {IChangePasswordForm, FieldsToVisible} from '../model';
import {FormValidationError, validationPipe} from '../../../../../shared/pipes/validation';
import View from './view';

import {useAppDispatch} from '../../../../../redux';
import {updateProfilePassword} from '../../../../../redux/actions/profile';
import {PasswordVisibleStates} from '../model';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../../../../shared/routing';
import {passwordValidator, passwordValidatorMessage} from '../../../../../shared/utils/validators';

const getFormErrors = (formData: IChangePasswordForm) =>
  validationPipe(formData, [
    {
      names: 'oldPassword',
      error: 'Обязательное поле',
      type: 'required',
    },
    {
      names: 'newPassword',
      error: 'Обязательное поле',
      type: 'required',
    },
    {
      names: 'newPassword',
      error: passwordValidatorMessage,
      type: 'custom',
      validator: passwordValidator,
    },
    {
      names: 'confirmPassword',
      error: 'Обязательное поле',
      type: 'required',
    },
    {
      names: 'newPassword,confirmPassword',
      error: 'Пароли не совпадают',
      type: 'equals',
    },
  ]);

const ChangePassword = (props: InjectedFormProps<IChangePasswordForm, {}, string>) => {
  const {handleSubmit} = props;
  const {navigate} = useNavigation();
  const dispatch = useAppDispatch();
  const [passwordVisibles, setNewPasswordVisible] = useState<PasswordVisibleStates>({
    newPassword: false,
    confirmPassword: false,
    currentPassword: false,
  });

  const onSubmit = async (form: IChangePasswordForm) => {
    const submissionError = getFormErrors(form);
    if (submissionError) {
      throw new SubmissionError(submissionError);
    }
    try {
      await dispatch(updateProfilePassword(form.oldPassword, form.newPassword));
    } catch (e: any) {
      let errorText = e.data?.[0]?.message || e.message || 'Ошибка. Повторите еще раз';
      throw new SubmissionError({
        oldPassword: new FormValidationError(errorText, true),
      } as FormErrors<any, FormValidationError>);
    }

    navigate(Screens.ProfileMenu);
  };

  const changeVisibility = (field: FieldsToVisible) => {
    const newPasswordVisibility = {
      ...passwordVisibles,
      [field]: !passwordVisibles[field],
    };
    setNewPasswordVisible(newPasswordVisibility);
  };
  return (
    <View onSubmit={() => handleSubmit(onSubmit)()} visible={passwordVisibles} changeVisibility={changeVisibility} />
  );
};

export const ChangePasswordMobile = reduxForm<IChangePasswordForm, {}>({
  form: Forms.changePassword,
  destroyOnUnmount: false,
})(ChangePassword);
